import { useState, useEffect } from 'react';
import { Dna, Microscope, FileSearch, Baby, Layers, TestTube, Beaker } from 'lucide-react';
import { Link } from 'react-router-dom';
import { API_URL } from '../config/api';
import './Tests.css';

const ICON_MAP = {
    Dna, Microscope, FileSearch, Baby, Layers, TestTube, Beaker
};

const Tests = () => {
    const [tests, setTests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTests();
    }, []);

    const fetchTests = async () => {
        try {
            const response = await fetch(`${API_URL}/genetic-tests`);
            const data = await response.json();
            if (data.success) setTests(data.data || []);
        } catch (error) {
            console.error('Error fetching tests:', error);
        } finally {
            setLoading(false);
        }
    };

    const getIcon = (iconName) => {
        const IconComponent = ICON_MAP[iconName] || Dna;
        return <IconComponent size={32} />;
    };

    // Fallback static tests if DB is empty
    const defaultTests = [
        { id: 1, name: "Cariotipo", description: "Análisis de cromosomas para detectar alteraciones.", category: "Citogenética" },
        { id: 2, name: "Microarreglos (CMA)", description: "Detección de microdeleciones/duplicaciones en ADN.", category: "Molecular" },
        { id: 3, name: "Paneles NGS", description: "Secuenciación de múltiples genes para diagnóstico específico.", category: "Secuenciación" },
        { id: 4, name: "NIPT", description: "Prueba prenatal no invasiva para trisomías.", category: "Prenatal" },
        { id: 5, name: "Exoma", description: "Análisis completo de la región codificante del genoma.", category: "Secuenciación" }
    ];

    const displayTests = tests.length > 0 ? tests : defaultTests;

    if (loading) {
        return <div style={{ padding: '40px', textAlign: 'center' }}>Cargando...</div>;
    }

    return (
        <div className="tests-page">
            <section className="page-header">
                <div className="container">
                    <h1 className="page-title">Pruebas Genéticas</h1>
                    <p className="page-subtitle">
                        Tecnología de vanguardia para obtener respuestas precisas sobre tu salud genética.
                    </p>
                </div>
            </section>

            <section className="section container">
                <div className="tests-list">
                    {displayTests.map((test) => (
                        <div key={test.id} className="test-item">
                            <div className="test-icon-box">
                                {getIcon(test.icon || 'Dna')}
                            </div>
                            <div className="test-content">
                                <h3 className="test-title">{test.name}</h3>
                                {test.description && test.description !== '0' && (
                                    <p className="test-description">{test.description}</p>
                                )}
                                <div className="test-tags">
                                    {test.category && <span className="test-tag">{test.category}</span>}
                                    {Number(test.turnaround_days) > 0 && (
                                        <span className="test-tag">{test.turnaround_days} días</span>
                                    )}
                                    {Number(test.price) > 0 && (
                                        <span className="test-tag price-tag">
                                            {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(test.price)}
                                        </span>
                                    )}
                                    {!!Number(test.is_featured) && (
                                        <span className="test-tag featured">Destacado</span>
                                    )}
                                </div>
                            </div>
                            <div className="test-action">
                                <Link to="/contacto" className="btn btn-outline btn-sm">
                                    Solicitar Info
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </section>


            <section className="section bg-light">
                <div className="container">
                    <div className="catalog-download-card">
                        <div className="catalog-info">
                            <div className="catalog-icon">
                                <FileSearch size={48} />
                            </div>
                            <div className="catalog-text">
                                <h2>Catálogo de Pruebas Completo</h2>
                                <p>Consulta nuestra guía detallada con todos los servicios y pruebas genéticas disponibles para descarga inmediata.</p>
                            </div>
                        </div>
                        <div className="catalog-action">
                            <a href="/Brochure-GeneCenter.pdf" download className="btn btn-primary">
                                Descargar Catálogo (PDF)
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section bg-primary text-white">
                <div className="container text-center">
                    <h2 style={{ color: 'white', marginBottom: '1rem' }}>¿Cómo solicitar una prueba?</h2>
                    <p style={{ maxWidth: '700px', margin: '0 auto 2rem', color: 'white', opacity: 1 }}>
                        La mayoría de las pruebas genéticas requieren una valoración médica previa.
                        Agenda una consulta con nosotros para guiarte.
                    </p>
                    <Link to="/contacto" className="btn btn-light">
                        Agendar Valoración
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Tests;

